import Button from '@/components/UI/Button';
import { HookFileInput } from '@/components/UI/HookForm/Form/File';

interface EmploymentTaxProps {
  onNext: () => void;
  onPrevious: () => void;
}

export const EmploymentTax = ({ onNext, onPrevious }: EmploymentTaxProps) => {
  return (
    <div className='p-6 space-y-6 sm:rounded-r-md sm:overflow-hidden'>
      <div>
        <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Employment & Tax</h3>
        <p className='mt-2 text-sm text-gray-600'>
          Provide the following documents for the buyer and every household member aged 18 or older. Check each item as you gather it.
        </p>
      </div>

      <div className='space-y-8'>
        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Most recent W-2 for each employer</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload W-2 forms from all employers for the most recent tax year</p>
            </div>
          </div>
          <HookFileInput
            name='employmentTax.w2Forms'
            label='W-2 Forms'
            multiple
            customClassName='mt-4'
            placeholder='Choose W-2 files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Most recent full IRS Form 1040 (all pages & schedules)</h4>
              <p className='text-sm text-gray-500 mt-1'>Include all pages and schedules from your most recent tax return</p>
            </div>
          </div>
          <HookFileInput
            name='employmentTax.irs1040Forms'
            label='IRS Form 1040'
            multiple
            customClassName='mt-4'
            placeholder='Choose IRS 1040 files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Two (2) most recent consecutive pay stubs for every current job</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload the two most recent pay stubs from each current employer</p>
            </div>
          </div>
          <HookFileInput
            name='employmentTax.payStubs'
            label='Pay Stubs'
            multiple
            customClassName='mt-4'
            placeholder='Choose pay stub files or drag and drop'
          />
        </div>
      </div>

      <div className='flex gap-4 justify-end mt-8'>
        <Button label='Previous' btnStyle='neutral' type='button' onClick={onPrevious} />
        <Button label='Next' btnStyle='primary' type='submit' />
      </div>
    </div>
  );
};
